function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Html, Image } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import VideoModalButton from "../molecules/VideoModalButton";
import ArrowLink from "./ArrowLink";
import Icon from "./Icon";
import IconSvg from "./IconSvg";
export default function Teaser(props) {
    var _props_type, _props_categories_industries, _props_categories_departments, _props_categories_useCases, _props_categories_getStarted, _props_categories_goDeeper, _props_categories_newsUpdates, _props_categories_foodForThought, _props_categories_eventType, _props_categories_tags, _props_categories_techniques;
    var categoryClasses = "text-[7px] md:text-[9px] text-gray-100 font-heading mb-2 px-2 py-1 bg-gray-10 rounded-full uppercase inline-block";
    var _props_externalUrl;
    var _obj;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx("", {
            "flex flex-col md:flex-row lg:flex-col h-full relative !p-0": props.image,
            "p-6 md:p-8 md:pt-10 flex flex-col h-full items-start": props.logo && !props.categories && !props.image || props.icon && !props.type || !props.type && props.description && !props.image,
            "flex flex-col justify-between": props.logo && props.icon || props.alignBottom === true,
            "h-full flex flex-col": props.ctas && props.type
        })
    }, props.logo ? /*#__PURE__*/ React.createElement("div", {
        className: clsx("", {
            "order-last flex flex-wrap w-full items-center gap-x-8 xl:gap-x-10 border-t border-t-gray-400 pt-5 mt-8 -mb-2.5 grayscale": props.icon && ![
                "Thoughts",
                "Create",
                "Webinar",
                "Video"
            ].includes(props.icon)
        })
    }, props.logo.map(function(item, index) {
        return /*#__PURE__*/ React.createElement("div", {
            key: index,
            className: clsx("", {
                "w-full md:w-1/3 lg:w-full absolute z-10 top-0 left-0 h-full": props.image,
                "": props.logo && props.logo.length > 1
            })
        }, /*#__PURE__*/ React.createElement("div", {
            className: clsx("", {
                "max-[767px]:aspect-w-8 max-[767px]:aspect-h-4 lg:aspect-w-8 lg:aspect-h-3": props.image && !props.logo,
                "h-[142px] flex items-center": props.ctas || props.logo && !props.image
            })
        }, /*#__PURE__*/ React.createElement("img", {
            height: "36",
            className: clsx("mb-5", {
                "md:mb-7": props.type,
                "absolute !w-auto !top-1/2 z-10 max-h-[30px] max-w-[80%] -translate-y-1/2 left-0 right-0 mx-auto": props.image,
                "max-w-[120px] max-h-[36px]": props.logo && !props.icon && !props.image,
                "max-w-[50px] md:max-w-[80px] max-h-[20px]": props.logo && props.icon,
                "mx-auto max-h-[60px] max-w-[190px]": props.ctas || props.logo && !props.image
            }),
            src: "".concat(item),
            alt: "".concat(props.title),
            loading: "lazy"
        })));
    })) : null, props.image ? /*#__PURE__*/ React.createElement("div", {
        className: "relative md:w-1/3 lg:w-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("max-[767px]:aspect-w-8 max-[767px]:aspect-h-4 lg:aspect-w-8 lg:aspect-h-3 relative block overflow-hidden h-full lg:h-auto", {
            "video-bg": props.type === "Video"
        })
    }, /*#__PURE__*/ React.createElement(Image, {
        source: props.image,
        className: "!absolute block w-full max-w-full object-cover h-full",
        alt: "".concat(props.title)
    })), props.type === "Video" && props.displayVideoInModal === true ? /*#__PURE__*/ React.createElement(VideoModalButton, {
        target: props.target,
        label: "",
        buttonClasses: "video-icon"
    }) : null) : null, /*#__PURE__*/ React.createElement("div", {
        className: clsx("", {
            "flex flex-col justify-between h-full md:w-2/3 lg:w-full relative z-10": props.image,
            "flex flex-col justify-between h-full": props.logo && props.type || !props.type && props.icon || props.alignBottom === true
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("", {
            "mb-2.5": !props.type && props.icon,
            "flex-1": props.ctas && props.type
        })
    }, !props.type && props.icon && props.iconUrl ? /*#__PURE__*/ React.createElement(IconSvg, {
        url: props.iconUrl,
        keyword: props.icon,
        className: "mb-4 w-9"
    }) : null, !props.type && props.icon && !props.iconUrl ? /*#__PURE__*/ React.createElement(Icon, {
        keyword: props.icon,
        className: "mb-4 w-9"
    }) : null, /*#__PURE__*/ React.createElement("div", {
        className: clsx("", (_obj = {
            "pt-6 pb-2.5 px-6 min-h-[190px] lg:min-h-0": props.image,
            "max-[767px]:pb-2.5": props.categories
        }, _define_property(_obj, "item-".concat((_props_type = props.type) === null || _props_type === void 0 ? void 0 : _props_type.replace(/\s+|[^A-Za-z0-9]/g, "")), props.type), _define_property(_obj, "h-full flex flex-col", props.ctas && props.type), _obj))
    }, props.type ? /*#__PURE__*/ React.createElement("div", {
        className: "md:flex items-start mb-2.5 teaser-type type-".concat(props.type.replace(/\s+|[^A-Za-z0-9]/g, ""))
    }, props.icon && props.iconUrl ? /*#__PURE__*/ React.createElement(IconSvg, {
        url: props.iconUrl,
        keyword: props.icon,
        className: "mb-3.5 md:mb-0 mr-2.5 w-[18px] h-[18px]"
    }) : null, props.icon && !props.iconUrl ? /*#__PURE__*/ React.createElement(Icon, {
        keyword: props.icon,
        className: "mb-3.5 md:mb-0 mr-2.5 w-[18px] h-[18px]"
    }) : null, /*#__PURE__*/ React.createElement("span", {
        className: "uppercase text-blue-500 text-xs md:text-sm font-heading tracking-wider font-semibold block"
    }, props.type)) : null, /*#__PURE__*/ React.createElement("div", {
        className: clsx("", {
            "md:pl-7": props.type && !props.image && !props.logo && !props.isEvent,
            "px-5 pb-7 flex flex-col justify-between h-full": props.ctas || props.logo && !props.image
        })
    }, !props.ctas && (props.type === "Video" && props.displayVideoInModal === true ? /*#__PURE__*/ React.createElement(VideoModalButton, {
        target: props.target,
        label: props.title,
        buttonClasses: "block text-xl text-left focus md:leading-tight mb-1 text-gray-600 hover:text-blue-500 transition-all font-heading md:text-[27px] font-medium md:mb-2.5"
    }) : /*#__PURE__*/ React.createElement("a", {
        target: props.externalUrl || props.openInNewTab ? "_blank" : "_self",
        rel: props.externalUrl || props.openInNewTab ? "noreferrer noopener" : "",
        href: (_props_externalUrl = props.externalUrl) !== null && _props_externalUrl !== void 0 ? _props_externalUrl : props.target,
        className: clsx("block text-xl focus md:leading-tight mb-1 text-gray-600 hover:text-blue-500 transition-all font-heading", {
            "md:text-3xl md:mb-3.5": props.type || props.date,
            "md:text-[27px] font-medium md:mb-2.5": props.description
        })
    }, /*#__PURE__*/ React.createElement("h4", null, /*#__PURE__*/ React.createElement(Html, {
        markup: props.title
    })))), (props.date || props.author) && /*#__PURE__*/ React.createElement("span", {
        className: clsx("text-sm", {
            "text-gray-200": !props.isEvent,
            "text-blue-500 font-medium": props.isEvent === true
        })
    }, props.date ? /*#__PURE__*/ React.createElement(React.Fragment, null, props.date) : null, props.date && props.author ? /*#__PURE__*/ React.createElement(React.Fragment, null, " | ") : null, props.author ? /*#__PURE__*/ React.createElement(React.Fragment, null, props.author) : null), props.description ? /*#__PURE__*/ React.createElement("div", {
        className: clsx("", {
            "line-clamp-6 mb-2": props.ctas
        })
    }, /*#__PURE__*/ React.createElement("p", {
        className: "block mb-3 text-gray-200 lg:text-lg lg:leading-snug mt-1 md:mt-2"
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: props.description
    }))) : null, props.categories && !props.ctas ? /*#__PURE__*/ React.createElement("ul", {
        className: "flex flex-wrap gap-x-2 mt-3 md:mb-5"
    }, (_props_categories_industries = props.categories.industries) === null || _props_categories_industries === void 0 ? void 0 : _props_categories_industries.map(function(industry) {
        /*#__PURE__*/ return React.createElement("li", {
            key: industry === null || industry === void 0 ? void 0 : industry.id,
            className: categoryClasses
        }, industry === null || industry === void 0 ? void 0 : industry.name);
    }), (_props_categories_departments = props.categories.departments) === null || _props_categories_departments === void 0 ? void 0 : _props_categories_departments.map(function(department) {
        /*#__PURE__*/ return React.createElement("li", {
            key: department === null || department === void 0 ? void 0 : department.id,
            className: categoryClasses
        }, department === null || department === void 0 ? void 0 : department.name);
    }), (_props_categories_useCases = props.categories.useCases) === null || _props_categories_useCases === void 0 ? void 0 : _props_categories_useCases.map(function(useCase) {
        /*#__PURE__*/ return React.createElement("li", {
            key: useCase === null || useCase === void 0 ? void 0 : useCase.id,
            className: categoryClasses
        }, useCase === null || useCase === void 0 ? void 0 : useCase.name);
    }), (_props_categories_getStarted = props.categories.getStarted) === null || _props_categories_getStarted === void 0 ? void 0 : _props_categories_getStarted.map(function(term) {
        /*#__PURE__*/ return React.createElement("li", {
            key: term === null || term === void 0 ? void 0 : term.id,
            className: categoryClasses
        }, term === null || term === void 0 ? void 0 : term.name);
    }), (_props_categories_goDeeper = props.categories.goDeeper) === null || _props_categories_goDeeper === void 0 ? void 0 : _props_categories_goDeeper.map(function(term) {
        /*#__PURE__*/ return React.createElement("li", {
            key: term === null || term === void 0 ? void 0 : term.id,
            className: categoryClasses
        }, term === null || term === void 0 ? void 0 : term.name);
    }), (_props_categories_newsUpdates = props.categories.newsUpdates) === null || _props_categories_newsUpdates === void 0 ? void 0 : _props_categories_newsUpdates.map(function(term) {
        /*#__PURE__*/ return React.createElement("li", {
            key: term === null || term === void 0 ? void 0 : term.id,
            className: categoryClasses
        }, term === null || term === void 0 ? void 0 : term.name);
    }), (_props_categories_foodForThought = props.categories.foodForThought) === null || _props_categories_foodForThought === void 0 ? void 0 : _props_categories_foodForThought.map(function(term) {
        /*#__PURE__*/ return React.createElement("li", {
            key: term === null || term === void 0 ? void 0 : term.id,
            className: categoryClasses
        }, term === null || term === void 0 ? void 0 : term.name);
    }), (_props_categories_eventType = props.categories.eventType) === null || _props_categories_eventType === void 0 ? void 0 : _props_categories_eventType.map(function(term) {
        /*#__PURE__*/ return React.createElement("li", {
            key: term === null || term === void 0 ? void 0 : term.id,
            className: categoryClasses
        }, term === null || term === void 0 ? void 0 : term.name);
    }), (_props_categories_tags = props.categories.tags) === null || _props_categories_tags === void 0 ? void 0 : _props_categories_tags.map(function(term) {
        /*#__PURE__*/ return React.createElement("li", {
            key: term === null || term === void 0 ? void 0 : term.id,
            className: categoryClasses
        }, term === null || term === void 0 ? void 0 : term.name);
    }), props.categories && "techniques" in props.categories ? (_props_categories_techniques = props.categories.techniques) === null || _props_categories_techniques === void 0 ? void 0 : _props_categories_techniques.map(function(technique) {
        /*#__PURE__*/ return React.createElement("li", {
            key: technique === null || technique === void 0 ? void 0 : technique.id,
            className: categoryClasses
        }, technique === null || technique === void 0 ? void 0 : technique.name);
    }) : null) : null, props.ctas ? /*#__PURE__*/ React.createElement("div", null, props.ctas.map(function(cta, key) {
        /*#__PURE__*/ return React.createElement("a", {
            key: key,
            href: cta === null || cta === void 0 ? void 0 : cta.target,
            id: cta === null || cta === void 0 ? void 0 : cta.label.replace(/\s+|[^A-Za-z0-9]/g, "").toLowerCase(),
            className: clsx("w-full mt-4 hover:bg-blue-500 hover:border-blue-500", {
                "button-secondary focus bg-white border-gray-600 text-gray-600 hover:text-white": (cta === null || cta === void 0 ? void 0 : cta.display) === "PRIMARY",
                "button-secondary border-gray-600 text-white bg-gray-600": (cta === null || cta === void 0 ? void 0 : cta.display) === "SECONDARY"
            })
        }, cta === null || cta === void 0 ? void 0 : cta.label);
    })) : null))), !props.ctas && ((props.logo || props.image || props.icon) && props.linkText || !props.type && props.description && props.target) ? /*#__PURE__*/ React.createElement("div", {
        className: clsx("", {
            "px-6 pt-3.5 pb-4 mt-1": props.image || props.logo && !props.icon,
            "pt-3": props.logo && props.type && !props.image || props.icon && !props.type
        })
    }, props.type === "Video" && props.displayVideoInModal === true ? /*#__PURE__*/ React.createElement(VideoModalButton, {
        target: props.target,
        label: "Watch video",
        arrowDisplay: true,
        buttonClasses: "text-sm font-heading font-semibold hover:text-blue-500 transition-all"
    }) : /*#__PURE__*/ React.createElement(ArrowLink, {
        text: props.linkText || "Learn more",
        external: (props === null || props === void 0 ? void 0 : props.externalUrl) || (props === null || props === void 0 ? void 0 : props.openInNewTab) ? true : false,
        target: (props === null || props === void 0 ? void 0 : props.externalUrl) ? props.externalUrl : (props === null || props === void 0 ? void 0 : props.target) ? props.target : "/",
        newTab: (props === null || props === void 0 ? void 0 : props.linkNewTab) || false
    })) : null));
}
